import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const RefreshIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path fill='currentColor' d='M12 6a6 6 0 1 0 5.37 8.68c.198-.396.585-.68 1.028-.68.684 0 1.184.649.904 1.272A8.001 8.001 0 0 1 4 12a8 8 0 0 1 13.657-5.657l.977-.977A.8.8 0 0 1 20 5.93V10a1 1 0 0 1-1 1h-4.069a.8.8 0 0 1-.565-1.366L16.22 7.78l.029-.017A5.982 5.982 0 0 0 12 6Z'/>
    </svg>
));
